// extracted by mini-css-extract-plugin
export default {"container":"PaymentResultPage_container__VCllP"};